"use client";

import { ArrowRight, CalendarCheck, ChefHat, PhoneCall, Sparkles } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ReadyToPlugIn() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const trustSignals = [{
    icon: CalendarCheck,
    label: "Live Availability"
  }, {
    icon: ChefHat,
    label: "Premium Backline"
  }, {
    icon: Sparkles,
    label: "Pro Tracking"
  }];
  return <section data-section-id="710" id="ready-to-plug-in" className="relative min-h-[80vh] w-full overflow-hidden bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1693037/img/garage_studio_rehearsal_grit.png)] bg-cover bg-center bg-fixed bg-background text-foreground">
      {}
      <div className="absolute inset-0 hidden md:block" style={{
      background: "linear-gradient(to right, hsl(220 15% 5% / 0.95) 0%, hsl(220 15% 5% / 0.8) 35%, hsl(220 15% 5% / 0.4) 70%, hsl(220 15% 5% / 0.2) 100%)"
    }} aria-hidden="true" />
      {}
      <div className="absolute inset-0 md:hidden" style={{
      background: "linear-gradient(to bottom, hsl(220 15% 5% / 0.8) 0%, hsl(220 15% 5% / 0.95) 100%)"
    }} aria-hidden="true" />

      {}
      <div className="absolute top-8 right-6 md:top-12 md:right-12 z-20 pointer-events-none">
        <div className="rounded-md border px-4 py-2 text-[0.7rem] tracking-[0.25em] font-mono uppercase backdrop-blur-sm" style={{
        color: "hsl(45 90% 50%)",
        borderColor: "hsl(45 60% 30% / 0.8)",
        backgroundColor: "hsl(220 15% 5% / 0.6)",
        transform: "rotate(6deg)"
      }}>
          <span className="inline-flex items-center gap-2">
            <span className="inline-block size-1.5 rounded-lg" style={{
            backgroundColor: "hsl(45 90% 50%)"
          }} />
            Peak Hours
            <span className="inline-block size-1.5 rounded-lg" style={{
            backgroundColor: "hsl(45 90% 50%)"
          }} />
            Filling Fast
            <span className="inline-block size-1.5 rounded-lg" style={{
            backgroundColor: "hsl(45 90% 50%)"
          }} />
          </span>
        </div>
      </div>

      {}
      <div ref={ref} className={`relative z-10 flex min-h-[80vh] items-center px-6 py-24 md:px-12 lg:px-16 md:py-32 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="w-full md:w-3/5 lg:w-1/2 text-center md:text-left">
          {}
          <div className="mb-6 inline-flex items-center gap-3">
            <span className="h-px w-10" style={{
            backgroundColor: "hsl(45 90% 50%)"
          }} aria-hidden="true" />
            <span className="font-mono text-xs tracking-[0.3em] uppercase" style={{
            color: "hsl(45 90% 50%)"
          }}>
              Now Tracking — Season 2024
            </span>
          </div>

          {}
          <h2 className="font-default font-bold leading-[0.9] tracking-tighter mb-8 uppercase" style={{
          color: "hsl(0 0% 95%)",
          fontSize: "clamp(2.75rem, 7vw, 6.5rem)"
        }}>
            Claim your{" "}
            <em className="italic font-normal" style={{
            color: "hsl(45 90% 50%)"
          }}>
              slot
            </em>{" "}
            before the noise stops.
          </h2>

          {}
          <p className="font-default text-lg md:text-xl leading-relaxed mb-10 max-w-xl mx-auto md:mx-0" style={{
          color: "hsl(220 5% 70%)"
        }}>
            The Garage Room is the heartbeat of the local scene. From raw rehearsals to 
            full-stack tracking, our calendar moves at the speed of sound. Download 
            our availability and lock in your session today.
          </p>

          {}
          <div className="flex flex-col sm:flex-row gap-4 mb-12 items-center md:items-start justify-center md:justify-start">
            <Button asChild size="lg" className="rounded-md h-14 px-8 text-base font-bold shadow-xl group transition-transform hover:translate-x-1 hover:translate-y-1" style={{
            backgroundColor: "hsl(45 90% 50%)",
            color: "hsl(220 15% 5%)"
          }}>
              <Link to="/BookPage">
                View Calendar
                <ArrowRight className="ml-1 size-5 transition-transform group-hover:translate-x-1" />
              </Link>
            </Button>

            <Button asChild variant="outline" size="lg" className="rounded-md h-14 px-8 text-base font-bold bg-transparent backdrop-blur-sm border-2" style={{
            borderColor: "hsl(45 90% 50%)",
            color: "hsl(45 90% 50%)"
          }}>
              <Link to="tel:5551233328">
                <PhoneCall className="size-4" />
                Call the Studio
              </Link>
            </Button>
          </div>

          {}
          <div className="flex flex-wrap items-center justify-center md:justify-start gap-x-2 gap-y-4">
            {trustSignals.map((signal, i) => {
            const Icon = signal.icon;
            return <div key={i} data-index={i} className="inline-flex items-center gap-2">
                  <Icon className="size-4" style={{
                color: "hsl(45 90% 50%)"
              }} />
                  <span className="font-mono text-xs tracking-[0.15em] uppercase" style={{
                color: "hsl(0 0% 95%)"
              }}>
                    {signal.label}
                  </span>
                  {i < trustSignals.length - 1 && <span className="mx-3 inline-block size-1 rounded-lg" style={{
                backgroundColor: "hsl(45 60% 30%)"
              }} aria-hidden="true" />}
                </div>;
          })}
          </div>
        </div>
      </div>
    </section>;
}